// @flow
import React, { type Node, Fragment } from 'react';


type Props = {
  startAt: string,
  endAt: string,
}

const Bells = ({ startAt, endAt }: Props): Node => {
  return (
    <Fragment>
      {startAt}
      {startAt && ' — '}
      {endAt}
    </Fragment>
  );
};

export default Bells;
